var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Modal',{attrs:{"persistent":"","cancelable":_vm.cancelable,"has-form":false,"show":_vm.show,"overlay":true,"class-object":['pa-4']},on:{"onClose":_vm.onClose}},[_c('v-card-text',{staticClass:"ma-0 pa-0"},[_vm._v(" "+_vm._s(_vm.description)+" "),_c('v-progress-linear',{staticClass:"my-1",attrs:{"indeterminate":"","color":"primary"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }